import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import mime from 'mime-types';
import { groups, DECREE, LAW_PASSPORT, DECREE_PASSPORT } from './groups';
import store from '../../store';
import './style.scss';
import { Field, Form, RelationSelect, Attachments } from '@smartplatform/ui';

@observer
export default class Document extends React.Component {
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		console.log('props', props);
		this.init();
	}

	@action init = async () => {
		this.id = this.props.match.params.id;
		try {
			this.record = await store.model.Document.findById(this.id, {
				include: [
					{ relation: 'baseLaw' },
					{ relation: 'withdrawalAttachments' },
					{
						relation: 'refLinks',
						scope: {
							where: { childId: { neq: null } },
							include: [
								{
									relation: 'child',
									scope: {
										include: [
											{
												relation: 'refFiles',
												scope: {
													fields: { id: true, description: true, filesize: true },
												},
											},
											{
												relation: 'refLinks',
												scope: {
													include: [
														{
															relation: 'child',
															scope: {
																fields: { id: true },
																include: [
																	{
																		relation: 'refFiles',
																		scope: {
																			fields: { id: true, description: true, filesize: true },
																		},
																	},
																],
															},
														},
													],
													where: {
														childId: { neq: null },
														kindLinkedDoc: 3,
													},
												},
											},
										],
									},
								},
							],
						},
					},
				],
			});
		} catch (e) {
			this.error = e.message;
		}
	};

	docFiles = document =>
		document.refFiles().map(refFile => (
			<li key={refFile.id}>
				<a href="#" onClick={e => this.downloadFile(e, refFile)}>
					{refFile.description}
				</a>
			</li>
		));

	refLinkFiles = refLink => <ul className="doc-files">{this.docFiles(refLink.child)}</ul>;

	downloadFile = async (e, refFile) => {
		try {
			const file = await refFile.docFile;
			const ext = file.fileExtension;
			const byteArray = file.contents;

			const type = mime.lookup(ext);

			if (type) {
				const blob = new Blob([new Uint8Array(byteArray.data).buffer], { type });
				console.log('blob', blob);
				const data = window.URL.createObjectURL(blob);

				if (type === 'application/pdf') {
					window.open(data, refFile.description);
				} else {
					const link = document.createElement('a');
					link.href = data;
					link.download = refFile.description;
					link.click();
				}
			} else {
				console.error('Unknown mime type for extension', ext);
			}
		} catch (e) {
			console.error(e);
		}
	};

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;

		const refLinks = this.record.refLinks().map(refLink => (
			<li key={refLink.id} className="step">
				<div className="step-name">{refLink.name}</div>
				<div className="step-doc">
					{refLink.child.name} (isn: {refLink.child.id}){this.refLinkFiles(refLink)}
					<ul className="substeps">
						{refLink.child.refLinks().map(refLink => (
							<li key={refLink.id} className="substep">
								<div className="substep-name">{refLink.name}</div>
								{this.refLinkFiles(refLink)}
							</li>
						))}
					</ul>
				</div>
			</li>
		));

		const type = groups[this.record.docGroup];
		let typePath = 'laws';
		if (this.record.docGroup === DECREE) {
			typePath = 'decrees';
		} else if (this.record.docGroup === LAW_PASSPORT) {
			typePath = 'law-projects';
		} else if (this.record.docGroup === DECREE_PASSPORT) {
			typePath = 'decree-projects';
		}

		return (
			<div className="doc-page">
				<p>
					<Link to={`/admin/documents/${typePath}`}>Назад</Link>
				</p>
				{type && <p>{type}</p>}
				<p>
					№ <strong>{this.record.freeNum}</strong>
				</p>
				<p>
					<strong>{this.record.name}</strong>
				</p>
				<hr />

				<ul className="steps">{refLinks}</ul>
				<Form record={this.record} rootPath="/admin/documents/" returnTo={`/admin/documents/${typePath}`}>
					<Field label="Базовый закон" relation="baseLaw" property="name">
						<RelationSelect />
					</Field>
					<Field property="hiddenNpa" label="Скрыть в НПА" />
					{typePath === 'law-projects' && Boolean(this.record.stageList) && (
						<Field label="Файлы к отзыву законопроекта">
							<Attachments
								record={this.record}
								relation="withdrawalAttachments"
								store={store.model}
								label="Файлы к отзыву законопроекта"
							/>
						</Field>
					)}
				</Form>
			</div>
		);
	}
}
